import React from "react";

export const Item = ({
  title,
  value,
  noMt = false,
  action,
}: {
  title: string;
  value?: React.ReactNode;
  noMt?: boolean;
  action?: React.ReactNode;
}) => (
  <div className={`grid grid-cols-3 ${!noMt ? "mt-6" : ""}`}>
    <div className="flex flex-col gap-6">
      <div>
        <p className="text-secondary font-manrope text-[14px] font-medium w-[100px] sm:w-[140px] flex-shrink-0">
          {title}:
        </p>
        <div className="flex items-center gap-2">
          <div className="text-primary font-manrope text-[14px] font-medium flex-shrink break-all">
            {value}
          </div>
          {action}
        </div>
      </div>
    </div>
  </div>
);